import { Camera, ShieldAlert, WalletCards } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { recordFunnelEvent } from '../api.js';
import { AppShell } from '../components/AppShell.js';
import { Button, Field, Notice, Textarea } from '../components/ui.js';
import { copy } from '../i18n.js';
import { useDraft } from '../state/DraftContext.js';

export function ProofPage() {
  const { draft, update, photo, setPhoto } = useDraft();
  const navigate = useNavigate();
  if (!draft) return null;
  const t = copy[draft.language];
  const next = () => {
    if (draft.walletPolicyRequired && !draft.walletPolicyShown) update({ walletPolicyShown: true });
    recordFunnelEvent({ type: 'STEP_VIEWED', step: 'PROOF', language: draft.language });
    navigate('/report/contact');
  };
  return (
    <AppShell language={draft.language} step={3}>
      <header className="page-heading">
        <h1>{t.proof.title}</h1>
        <p>{t.proof.lead}</p>
      </header>
      {draft.walletPolicyRequired ? (
        <Notice tone="warning">
          <WalletCards size={20} />
          {t.proof.wallet}
        </Notice>
      ) : null}
      <Notice tone="info">
        <ShieldAlert size={20} />
        {t.proof.secrets}
      </Notice>
      <section className="flow-card proof-card">
        <Field label={t.proof.description}>
          <Textarea
            rows={4}
            value={draft.proofDescription}
            onChange={(event) => update({ proofDescription: event.target.value })}
            placeholder={t.proof.placeholder}
          />
        </Field>
        <label className="upload-box">
          <input
            type="file"
            accept="image/jpeg,image/png,image/webp,image/heic,image/heif"
            onChange={(event) => setPhoto(event.target.files?.[0] ?? null)}
          />
          <Camera aria-hidden />
          <strong>{photo ? photo.name : t.proof.photo}</strong>
          <small>{t.proof.photoHint}</small>
        </label>
        {photo && photo.size > 10_000_000 ? (
          <Notice tone="danger">The photo is larger than 10 MB.</Notice>
        ) : null}
      </section>
      <div className="flow-actions">
        <Button variant="secondary" onClick={() => navigate('/report/place')}>
          {t.common.back}
        </Button>
        <Button disabled={Boolean(photo && photo.size > 10_000_000)} onClick={next}>
          {t.common.continue}
        </Button>
      </div>
    </AppShell>
  );
}
